export const AUTH_CALLBACK_PARAMETER = 'auth_callback';
